import React from 'react';
import { SectionHeading } from '../ui/SectionHeading';
import { ButtonLink } from '../ui/ButtonLink';
import { ImageSourceBadge } from '../ui/ImageSourceBadge';
import { DiagonalAccent } from '../ui/DiagonalAccent';
import { images } from '../../data/images';
import { company } from '../../data/site';
const facts = [{
  label: 'Incorporated',
  value: company.incorporated
}, {
  label: 'Ownership',
  value: company.ownership
}, {
  label: 'Registration no.',
  value: company.registrationNumber
}, {
  label: 'Based in',
  value: 'Gaborone'
}];
export function CompanyIntro() {
  return <section aria-labelledby="intro-title" className="bg-charcoal py-20 md:py-28" data-id="element-132" data-mp="iu0ev514b2yd">
      <div className="mx-auto grid max-w-site items-center gap-14 px-5 md:px-8 lg:grid-cols-12 lg:gap-16" data-id="element-133" data-mp="nsk4bfex6wvh">
        <div className="lg:col-span-6" data-id="element-134" data-mp="2d7rlrws2b8q4">
          <SectionHeading id="intro-title" label="Who we are" title="Engineering solutions for a stronger Botswana" data-id="element-135" data-mp="2d8t7qwam9fmm" />
          <div className="mt-7 space-y-4 text-[17px] leading-relaxed text-steel-200" data-id="element-136" data-mp="2i5td14zn6eco">
            <p data-id="element-137" data-mp="sbea3pqzx2rx">
              Liftoff Investments (Pty) Ltd is a citizen-owned Botswana company, incorporated in May 2007 and based in
              Gaborone. It works in construction, civil engineering and infrastructure for government ministries,
              parastatals, mining companies and private developers.
            </p>
            <p data-id="element-138" data-mp="x60cj3f3nkzv">
              Its documented capabilities cover roadworks, civil works, water and wastewater (sanitation), building and
              structural construction, stormwater drainage and culverts, paving, road maintenance, and associated
              infrastructure.
            </p>
          </div>
          <dl className="mt-10 grid grid-cols-2 border-t border-white/15" data-id="element-139" data-mp="edfvqkcod6cf">
            {facts.map(fact => <div key={fact.label} className="border-b border-white/15 py-4 pr-4" data-id="element-140" data-mp="1uqwkqykaf7v5">
                <dt className="text-[12px] font-semibold uppercase tracking-[0.14em] text-steel-400" data-id="element-141" data-mp="1pslcgs9n55f1">{fact.label}</dt>
                <dd className="mt-1 font-display text-[22px] font-bold uppercase text-white" data-id="element-142" data-mp="1xtkdnzx10u4h">{fact.value}</dd>
              </div>)}
          </dl>
          <ButtonLink to="/about/company-background" variant="outline" showArrow className="mt-10" data-id="element-143" data-mp="21wpapmyc83lq">
            Company Background
          </ButtonLink>
        </div>

        <div className="relative lg:col-span-6" data-id="element-144" data-mp="2brhbezn7v6kq">
          <div className="relative aspect-[4/3] overflow-hidden lg:aspect-[5/4]" data-id="element-145" data-mp="1e51ubyypcaxp">
            <img src={images.backhoe.src} alt={images.backhoe.alt} loading="lazy" decoding="async" className="h-full w-full object-cover" data-id="element-146" data-mp="1e374q7chjuna" />
            <ImageSourceBadge source={images.backhoe.source} className="absolute bottom-3 right-3" data-id="element-147" data-mp="1sto6xswy2ol8" />
          </div>
          <DiagonalAccent className="absolute -bottom-5 left-6 h-10 w-32" data-id="element-148" data-mp="vfbxz7fajh3o" />
        </div>
      </div>
    </section>;
}